<template>
  <div>
    <el-dialog title="需求公告" :visible.sync="visible" :close-on-click-modal="false" width="600px"
      class="ecology-notice-list">
      <div class="content" v-infinite-scroll="getDataList">
        <template v-if="showList.length > 0">
          <div class="p-y-10 b-line pointer" v-for="(item, index) in showList" :key="index" @click="onShowDetail(item)">
            <div class="flex-line-center between mb-8">
              <div class="title">{{ item.projectName }}</div>
              <div class="ml-8">
                <span class="tag1" v-if="item.ssoDemandStatus == 1">已接单</span>
                <span class="tag2" v-if="item.ssoDemandStatus == 2">已完成</span>
                <span class="tag3" v-else-if="item.ssoDemandStatus == 3">已过期</span>
              </div>
            </div>
            <div class="between">
              <div>
                <span class="label">发布时间：</span><span class="time">{{ item.publishTime || '-' }}</span>
              </div>
              <div>
                <span class="label">有效期：</span><span class="time">{{ item.validityPeriod || '-' }}</span>
              </div>
            </div>
          </div>
        </template>
        <el-empty v-else description="暂无内容"></el-empty>
      </div>

    </el-dialog>
    <NoticeDetail ref="noticeDetail" />
  </div>
</template>

<script>
import NoticeDetail from "./detail";

export default {
  components: {
    NoticeDetail
  },
  data() {
    return {
      visible: false,
      showList: [],
      page: {
        page: 0,
        limit: 10,

      },
      isEnd: false
    };
  },
  methods: {
    onShow() {
      this.visible = true;
    },
    getDataList() {
      if (this.isEnd) {
        return
      }
      this.page.page += 1
      this.$http.post(`/front/oms/omsSsoDemand/page`, { ...this.page }).then(({ data: res }) => {
        if (res.code === 0 && res.data) {
          const list = res.data.records || []
          this.showList.push(...list)
          if (list.length < this.page.limit) {
            this.isEnd = true
          }
        }
      })
    },
    onShowDetail(res) {
      this.$refs.noticeDetail.onShow(res)
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 640px;
  overflow: auto;
  padding: 10px 20px;
}

.p-y-10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.flex {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
}

.title {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.txt {
  font-family: Alibaba PuHuiTi;
  font-size: 12px;
}

.label {
  @extend .txt;
  color: #666666;
}

.time {
  @extend .txt;
  font-weight: 600;
  color: #333333;
}

.ml-8 {
  margin-left: 8px;
}

.tag {
  @extend .txt;
  color: #ffffff;
  display: inline-block;
  height: 20px;
  line-height: 16px;
  border-radius: 10px;
  padding: 2px 8px;
}

.tag1 {
  @extend .tag;
  background: #1fbd13;
}

.tag2 {
  @extend .tag;
  background: #2a54d1;
}

.tag3 {
  @extend .tag;
  background: #ccc;
}

.b-line {
  border-bottom: 1px solid #eeeeee;
}

.flex-line-center {
  display: flex;
  align-items: center;
}

.mb-8 {
  margin-bottom: 8px;
}

.pointer {
  cursor: pointer;
}
</style>
<style lang="scss">
.ecology-notice-list {
  .el-dialog__header {
    box-shadow: inset 0px -1px 0px 0px #e1e3e5;
  }

  .el-dialog__title {
    font-family: Alibaba PuHuiTi;
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .el-icon-close {
    color: #333;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>